import React, { createContext, useContext, useState } from 'react'

type FormDialogContextProps = {
  disabled: boolean;
  setDisabled: (value: boolean) => void;
}

const FormDialogContext = createContext<FormDialogContextProps | undefined>(undefined)

type FormDialogProviderProps = {
  children: React.ReactNode;
}

const FormDialogProvider = ({ children }: FormDialogProviderProps) => {
  const [ disabled, setDisabled ] = useState<boolean>(false)
  return (
    <FormDialogContext.Provider value={{
      disabled,
      setDisabled
    }}>
      {children}
    </FormDialogContext.Provider>
  )
}

class FormDialogProviderError extends Error {

}

export const useFormDialogContext = () => {
  const context = useContext(FormDialogContext)
  if(!context) {
    throw new FormDialogProviderError('Form Dialog Provider not initialized')
  }
  return context
}

export default FormDialogProvider